import React, { useMemo } from 'react'

import { Tag } from '@fourthwall/components'

import * as S from './Podcast.styled'

type PodcastProps = {
  status: 'Created' | 'Syncing' | 'Synced' | 'Errored'
  artworkUrl: string
  title: string
  url?: string
  onClick: () => void
}

export const Podcast = ({ status, artworkUrl, title, url, onClick }: PodcastProps) => {
  const tag = useMemo(() => {
    if (status === 'Created') {
      return <Tag appearance="default" label="Not synced" />
    }
    if (status === 'Syncing') {
      return <Tag appearance="default" label="Syncing..." />
    }
    if (status === 'Errored') {
      return <Tag appearance="alert" label="Sync failed" />
    }

    return <Tag appearance="success" label="Synced" />
  }, [status])

  return (
    <S.Container onClick={onClick}>
      <S.Inner>
        <S.Artwork src={artworkUrl} />
        <S.Info>
          {tag}
          <S.TitleContainer>
            <S.Title>{title}</S.Title>
            {url && <S.Url>{url}</S.Url>}
          </S.TitleContainer>
        </S.Info>
      </S.Inner>
    </S.Container>
  )
}
